import { z } from 'zod';

/**
 * Type d'événement enregistré dans `lead_events`. Une ligne par
 * transition métier importante : création, statut, consentement,
 * livraison, archivage. La timeline UI lit cette table.
 */
export const LeadEventKind = {
  created: 'created',
  status_changed: 'status_changed',
  consent_changed: 'consent_changed',
  consent_otp_sent: 'consent_otp_sent',
  consent_otp_verified: 'consent_otp_verified',
  delivered: 'delivered',
  delivery_failed: 'delivery_failed',
  non_vente_reason_set: 'non_vente_reason_set',
  /** Hopti incoming-lead-sync : Hopti a récupéré le lead en
   * vue de le pousser au partenaire final. meta : `{ hoptiStatus,
   * incomingLeadId, reason? }`. Émis depuis hopti-sync. */
  hopti_received: 'hopti_received',
  /** Qualification callcenter post-livraison remontée depuis hipto-crm-module
   * via le topic Pub/Sub `doorly-qualification-sync`. adminOnly=true par
   * défaut : la qualif arrive masquée pour les vendors, un admin doit la
   * promouvoir unitairement (PATCH /lead-events/:id/promote) pour la rendre
   * visible. Ne déclenche AUCUN changement de Lead.status — purement
   * informatif. meta : `{ qualificationId, rawLabel, category,
   * qualificationDate, callDate?, attemptNumber?, agentId?, aht?,
   * source: 'manager'|'hopti', ccAccountId? }`. */
  qualification_received: 'qualification_received',
  /** SMS de bienvenue envoyé au prospect à la livraison effective de la
   * fiche (flag `features.welcomeSms`). meta : `{ smsLogId, source,
   * segments, dryRun, mirrorPhone? }`. Visible par tous les rôles : le
   * vendeur doit savoir ce que son prospect a reçu. */
  welcome_sms_sent: 'welcome_sms_sent',
  /** Le vendeur a ouvert Messages avec un SMS préétabli pour ce prospect,
   * depuis SON téléphone (Doorly n'envoie rien). meta : `{ template,
   * segments, mirrorPhone? }`. Visible par tous les rôles ; sert aussi de
   * compteur : deux par fiche (`VENDOR_SMS_MAX_PER_LEAD`). */
  vendor_sms_prepared: 'vendor_sms_prepared',
  /** Réattribution de la fiche par le back-office (réunion du 09/10/2026) :
   * magasin, vendeur, superviseur et/ou manager. Un seul event par appel,
   * jamais quand rien ne change. meta : `{ changes: { field, from, to,
   * fromLabel?, toLabel? }[], reason? }` (cf. `ReattributedMetaSchema`).
   * Visible de tous les rôles qui voient la fiche. */
  reattributed: 'reattributed',
  archived: 'archived',
  restored: 'restored',
} as const;

export type LeadEventKind = (typeof LeadEventKind)[keyof typeof LeadEventKind];

export const LeadEventKindSchema = z.nativeEnum(LeadEventKind);
